import { InjectionToken } from "@angular/core";
import { Observable } from 'rxjs';

export const SERVER_TIME_TOKEN = new InjectionToken<ServerTime>('ServerTime');

export interface ServerTime {
    fetchServerTime(): Observable<number>;
}